<template>
  <div class="custom-fab-btn text-xs-center">
    <v-btn @click="handleClick()" fab dark large color="primary">
      <v-icon v-if="!icon" dark>add</v-icon>
      <v-icon v-if="icon" dark>{{icon}}</v-icon>
    </v-btn>
    <div class="fab-text font-weight-bold text-uppercase">
      <slot></slot>
    </div>
  </div>

</template>

<script>

export default {
  name: 'CustomFabBtn',
  props: ['icon'],
  methods: {
    handleClick () {
      this.$emit('click-fab')
    }
  }
}

</script>

<style lang="scss" scoped>

.custom-fab-btn{
  margin-top: 20px;
}

.fab-text{
  color: #378e07;
  font-size: 16px;
}

</style>
